<template>
  <div>
    <el-header class="header_wrapper"
      ><div class="header_left" :style="{ width: isCollapse ? '65px' : '' }">
        <a href="https://www.sbgw.cn/" target="_blank">
          <img class="logo" src="../../assets/images/zsb_logo.png" alt="" />
        {{siteName}}
        </a>
      </div>
      <div class="header_right">
        <el-dropdown class="fr right_dropdown">
          <span>
            <el-icon :size="18"><User /></el-icon>
            {{ userName }}
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item @click="logoutClick">安全退出</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </el-header>
  </div>
</template>

<script>
import { logOut } from "network/login.js";
import { onMounted } from "vue";
import store from "../../store/index";
export default {
  name: "Header",
  components: {},
  data() {
    return {};
  },
  setup() {
    // mounted
    onMounted(() => {});
  },
   props: {
    isCollapse: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // 项目名称
    siteName(){
      if (
        this.$store.state.AdminCache ||
        sessionStorage.getItem("AdminCache")
      ) {
        var title =
          this.$store.state.AdminCache.siteName ||
          sessionStorage.getItem("AdminCache").siteName;
      }
      return title
    },
    // 获取存储的登录信息
    userName() {
      if (
        this.$store.state.AdminCache ||
        sessionStorage.getItem("AdminCache")
      ) {
        var name =
          this.$store.state.AdminCache.name ||
          sessionStorage.getItem("AdminCache").name;
      }
      return decodeURIComponent(name);
    },
  },
  methods: {
    // 退出登录
    logoutClick() {
      logOut();
    },
  },
};
</script>

<style scoped>
.header_wrapper {
  height: 47px;
  line-height: 47px;
  background-color: #4d5b69;
  color: #fff;
  overflow: hidden;
}
.logo {
  width: 30px;
  height: 28px;
}
.header_left {
  font-size: 18px;
  font-weight: bold;
  /* text-align: center; */
  background-color: #4d5b69;
  width: 200px;
  float: left;
  padding-left: 22px;
   overflow: hidden;
}

.header_left a {
  color: #fff;
}

.header_right {
  padding: 0 15px;
  margin-left: 200px;
}
.header_wrapper .el-icon {
  vertical-align: middle;
  margin-bottom: 4px;
}
.right_dropdown {
  line-height: 45px;
  text-align: center;
  cursor: pointer;
  color: #fff;
}
.el-tooltip__trigger {
  outline: none;
}
</style>